<template>
  <VueMarkdownEditor
    :key="getProp('editorKey')"
    :value="getProp('value', '')"
    :text="getProp('value', '')"
    :mode="getProp('mode')"
    :height="getProp('height')"
    :tab-size="getProp('tabSize')"
    :toc-nav-position-right="getProp('tocNavPositionRight')"
    :default-show-toc="getProp('defaultShowToc')"
    :placeholder="getProp('placeholder')"
    :autofocus="getProp('autofocus')"
    :default-fullscreen="getProp('defaultFullscreen')"
    :include-level="getProp('includeLevel')"
    :left-toolbar="getProp('leftToolbar')"
    :right-toolbar="getProp('rightToolbar')"
    :toolbar="getProp('toolbar')"
    :toolbar-config="getProp('toolbarConfig')"
    :disabled-menus="getProp('disabledMenus')"
    :upload-image-config="getProp('uploadImageConfig')"
    :before-preview-change="getProp('beforePreviewChange')"
    :codemirror-config="getProp('codemirrorConfig')"
    :codemirror-style-reset="getProp('codemirrorStyleReset')"
    :style="getProp('styleValue')"
    :class="getProp('editorClass')"
    class="clicMarkdown"
    @change="handleChange"
    @blur="handleBlur"
    @save="handleSave"
    @image-click="handleImageClick"
    @fullscreen-change="handleFullscreenChange"
    @upload-image="handleUploadImage"
    @input="handleInput"
  />
</template>

<script>
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import hljs from 'highlight.js';
import createMermaidPlugin from '@kangc/v-md-editor/lib/plugins/mermaid/npm';
import '@kangc/v-md-editor/lib/plugins/mermaid/mermaid.css';
import ComponentInternalMixin from '../../core/ComponentInternalMixin';

let isMarkdownConfigured = false;

const configureMarkdownEditor = () => {
  if (isMarkdownConfigured) {
    return;
  }

  VueMarkdownEditor.use(githubTheme, {
    Hljs: hljs,
  });

  VueMarkdownEditor.use(createMermaidPlugin());

  isMarkdownConfigured = true;
};

configureMarkdownEditor();

export default {
  name: 'ClicMarkdownInterno',
  inheritAttrs: false,
  mixins: [ComponentInternalMixin],
  components: {
    VueMarkdownEditor
  },
  computed: {
    idiomaValue() {
      return this.getProp('idioma');
    }
  },
  mounted() {
    this.applyLanguage();
  },
  watch: {
    idiomaValue() {
      this.applyLanguage();
    }
  },
  methods: {
    applyLanguage() {
      const languageContent = this.idiomaValue?.PT;
      if (languageContent) {
        VueMarkdownEditor.lang.use('idioma', languageContent);
      }
    },
    handleInput(value) {
      this.$emit('input', value);
    },
    handleChange(text, html) {
      this.$emit('change', text, html);
    },
    handleBlur(event) {
      this.$emit('blur', event);
    },
    handleSave(text, html) {
      this.$emit('save', text, html);
    },
    handleImageClick(images, currentIndex) {
      this.$emit('image-click', images, currentIndex);
      this.$emit('imageClick', images, currentIndex);
    },
    handleFullscreenChange(isFullscreen) {
      this.$emit('fullscreen-change', isFullscreen);
      this.$emit('fullscreenChange', isFullscreen);
    },
    handleUploadImage(event, insertImage, files) {
      this.$emit('upload-image', event, insertImage, files);
      this.$emit('uploadImage', event, insertImage, files);
    }
  }
};
</script>
